'use strict'

class TemplateFormCtrl {

    constructor ($rootScope, $scope, $http, $state, $stateParams, $mdToast, $mdDialog, bladesManager, TemplateItem, Template, $transitions) {
        this.$http = $http
        this.$state = $state
        this.$scope = $scope
        this.$stateParams = $stateParams
        this.templateData = {}
        this.templateData.items = []
        this.isSaved = false
        this.programs = []
        this.$mdToast = $mdToast
        this.$mdDialog = $mdDialog
        this.searchTerm = ''
        this.formdataCopy = null
        this._Template = Template
        this._Item = TemplateItem

        this.create = $stateParams.create

        if ($stateParams.id) {
            this._Template.get({ id: $stateParams.id }, (data) => {
                angular.extend(this.templateData, data)
                this.formdataCopy = angular.copy(this.templateData)
            })
        }

        $scope.$on('template_item_created', this.add_item.bind(this))

        this.fetchPrograms()

        this.sortableOptions = {
            axis: 'y',
            opacity: 0.6,
            items: 'md-list-item:not([disabled])',
            placeholder: 'md-list-item--sortable-placeholder'
        }

        //Fixed (custom) blade management
        this.unregister = $transitions.onSuccess({}, function (transition) {
            let to = transition.to()
            if (!to.name.startsWith('template.update.item')) {
                if (bladesManager.all(0).some(el => el.viewName === 'itemDetail')) {
                    bladesManager.removeRight('itemDetail')
                }
            }
        })

        this.unregisterStateChangeStart = $transitions.onStart({}, this.stateChangeStart.bind(this))

        $scope.$on('$destroy', () => {
            this.unregister()
            this.unregisterStateChangeStart()
        })
    }

    fetchPrograms () {
        return this.$http.get('/programs/all')
            .then(result => {
                return this.programs = result.data
            })
    }

    stopKeyDown (ev) {
        ev.stopPropagation()
    }

    stateChangeStart (transition) {
        if (transition) {

            let to = transition.to()
            let toParams = transition.params()

            let templateCopy = this.templateData
            let formdataCopy = this.formdataCopy

            formdataCopy.$promise = templateCopy.$promise

            formdataCopy.program_ids = templateCopy.program_ids

            if (
                to.name.indexOf('template.update') === -1 ||
                toParams.id !== this.$stateParams.id
            ) {

                if (!angular.equals(templateCopy, formdataCopy) && this.isSaved == false) {
                    transition.abort()
                    this.userWasWarned = true
                    this.$mdDialog.show({
                        controller: 'ConfirmDialogCtrl',
                        templateUrl: 'unsavedDataDialog.ngTemplate',
                        parent: angular.element(document.querySelector('#popupContainer')),
                        clickOutsideToClose: true
                    }).then(() => {
                        this.isSaved = true
                        this.$state.go(to, toParams)
                    }).catch(() => {

                    })
                }
            }
        }

        //
        // //Dirty Timezone fix
        // let checkFormData = Object.assign({}, this.formdata);
        // checkFormData.start = new Date(checkFormData.start.setHours(0));
        // checkFormData.stop = new Date(checkFormData.stop.setHours(0));
        //
        // if (!angular.equals(checkFormData, this.formdataCopy) && !this.doNotWarn) {
        //
        //     //Stop changing state
        //     event.preventDefault();
        //
        //     this.$mdDialog.show({
        //         controller: 'ConfirmDialogCtrl',
        //         templateUrl: "confirmDialog.ngTemplate,
        //         parent: angular.element(document.querySelector('#popupContainer')),
        //         clickOutsideToClose: true
        //     }).then((event) => {
        //
        //         this.doNotWarn = true;
        //         this.$state.go(to, toParams);
        //     }).finally((sss) => {
        //
        //         //console.log('vervolg state change', sss);
        //     });
        // }
    }

    clearSearchTerm () {
        this.searchTerm = ''
    }

    save ($valid) {
        //Check if form is valid
        if (!$valid) {
            return
        }

        let modelData = angular.copy(this.templateData)

        modelData.items = modelData.items.map(function (item, index) {
            item.order = index
            return item
        })

        //Save template object
        this._Template.save(modelData, () => {
            //Go back to the update view of just created template
            this.$state.go('template.update', { id: this.templateData.id }, { reload: true })
        })

        this.isSaved = true

        //Show notifications
        if (!this.create) {
            this.$mdToast.show({
                templateUrl: '/partial/app.partials.toasts.saved?object=template&title=' + this.templateData.title, //@trans('labels.template')
                hideDelay: 6000,
                position: ('top right')
            })
        } else {
            this.$mdToast.show({
                templateUrl: '/partial/app.partials.toasts.create?object=template&title=' + this.templateData.title,  //@trans('labels.template')
                hideDelay: 6000,
                position: ('top right')
            })
        }
    }

    cancel () {
        this.$state.go('^')
    }

    destroy (index, ev) {
        ev.stopPropagation()

        this.$mdDialog.show({
            controller: 'ConfirmDialogCtrl',
            templateUrl: 'confirmDialog.ngTemplate',
            parent: angular.element(document.querySelector('#popupContainer')),
            targetEvent: ev,
            clickOutsideToClose: true
        }).then(() => {
            this.templateData.items.splice(index, 1)
        })
    }

    add_item ($e, $data) {
        if ($data.hasOwnProperty('_id')) {
            var existing_item = this.templateData.items.filter(function (item) {
                return $data._id == item._id
            })[0]

            angular.extend(existing_item, $data)
            if (existing_item.id == 0) {
                existing_item.id = undefined
            }
        } else if ($data.hasOwnProperty('id')) {
            var existing_item = this.templateData.items.filter(function (item) {
                return $data.id == item.id
            })[0]

            angular.extend(existing_item, $data)
            if (existing_item.id == 0) {
                existing_item.id = undefined
            }
        } else {
            $data._id = Math.round(Math.random() * 1000)
            this.templateData.items.push($data)
        }
    }

    item () {

        this.$state.go('template.update.item', {
            'item_data': null,
            'item_id': null,
            'id': this.templateData.id,
            'ac': Math.round(Math.random() * 100)
        })
    }

    updateItem (item) {
        if (!item.id) {
            item.id = 0
        }

        //this.$state.go( stateUrl,  { ac: Math.round(Math.random() * 100) });
        this.$state.go('template.update.item', {
            'item_id': item.id,
            'item_data': item,
            'id': this.templateData.id,
            'ac': Math.round(Math.random() * 100)
        })
    }

    totalTime () {
        let totalDuration = this.templateData.items.reduce(function (maxDuration, item) {
            return maxDuration + parseInt(item.duration, 10)
        }, 0)
        return totalDuration
    }
}

TemplateFormCtrl.$inject = ['$rootScope', '$scope', '$http', '$state', '$stateParams', '$mdToast', '$mdDialog', 'bladesManager', 'TemplateItem', 'Template', '$transitions']

module.exports = TemplateFormCtrl
